<h1 i18n="@@upp.hotels.search.title">Search Hotel Rules</h1>

<div class="container-fluid">
  <ama-loading-alert
    [sendingStatus]="(hotelRuleDeleteSending$ | async) ?? false"
    message="Loading..."
    i18n-message="@@upp.global.messages.loading"
  >
  </ama-loading-alert>
</div>

<ama-upp-notification
  id="markets-search-notification"
  class="col"
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<ama-ng-upp-hotels-search-criteria
  (searchHotels)="searchHotelRules($event)"
  (clearHotels)="clearHotelRules()"
  [sendingStatus]="(hotelRuleSearchSending$ | async) ?? false"
>
</ama-ng-upp-hotels-search-criteria>

@if (!agGridTablesActivated) {
<ama-ng-upp-basic-search-result-table
  [searchResults]="(hotelRules$ | async) ?? undefined"
  [sendingStatus]="(hotelRuleSearchSending$ | async) ?? false"
  [sourceComponent]="getSourceComponent()"
  [entryType]="getEntryType()"
  [recordToSearchResult]="recordToSearchResult"
  [entryToUpdateCreator]="entryToUpdateCreator"
  [entryToUpdateNameResolver]="entryToUpdateNameResolver"
  [showHistoryButton]="displayRuleHistory"
  (deleteEntry)="deleteHotelRule($any($event))"
  (clearTableEvent)="clearHotelRules()"
  (showDetail)="showHotelRule($event)"
  (modifyDetail)="modifyHotelRule($event)"
  (copyDetail)="copyHotelRule($event)"
  (showHistoryPopup)="showHistory($event)"
  [copyForbidden]="!hotelsV2"
  [managePermission]="managePermission"
  [displayableFields]="displayableFields"
  [nameColumnPosition]="troubleShootingEnabled ? 'displayableFields' : 'first'"
></ama-ng-upp-basic-search-result-table>
} @else {
<div class="row mt-7">
  <div id="search-result" class="col">
    <div [class]="agGridTheme" class="grid-container">
      <ag-grid-angular
        [rowData]="(transformedHotelRules$ | async) ?? []"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        class="grid-component"
      ></ag-grid-angular>
    </div>
  </div>
</div>
}
